import { AddCreditsModal } from "components/ConnectCloudsOrCardModal/AddCreditsModal";
import ConnectCloudsOrCardModal from "components/ConnectCloudsOrCardModal";
import { BillingContext } from "contexts/BillingContext";
import { OneClickDeployContext } from "contexts/OneClickDeployContext";
import React from "react";

const AppShellBillingModal: React.FC = () => {
  const billingContext = React.useContext(BillingContext);
  const oneClickDeployContext = React.useContext(OneClickDeployContext);
  const isOpen = oneClickDeployContext.showConnectCloudsOrCardModal;

  const closeAndReset = () => {
    oneClickDeployContext.setShowConnectCloudsOrCardModal(false);
    oneClickDeployContext.reset();
  };

  if (!isOpen) return null;

  if (billingContext.billingProfile?.billing_type === "credit") {
    return (
      <AddCreditsModal
        show={isOpen}
        setShow={oneClickDeployContext.setShowConnectCloudsOrCardModal}
        onCancel={closeAndReset}
        setNoCardOnFile={oneClickDeployContext.setNoCardOnFile}
        noCardOnFile={oneClickDeployContext.noCardOnFile}
        onSuccess={closeAndReset}
      />
    );
  }

  return (
    <ConnectCloudsOrCardModal
      show={isOpen}
      setShow={oneClickDeployContext.setShowConnectCloudsOrCardModal}
      onCancel={closeAndReset}
      setNoCardOnFile={oneClickDeployContext.setNoCardOnFile}
      onSuccess={closeAndReset}
      setSelectedCloudName={oneClickDeployContext.setSelectedCloudName}
      selectedCloudName={oneClickDeployContext.selectedCloudName}
    />
  );
};

AppShellBillingModal.displayName = "AppShellBillingModal";

export default AppShellBillingModal;
